import {isNullOrUndefined} from "../../../services/Validator";

export default function DetailedCourseLevelASubthemeText({subtheme}) {
    // Used in DetailedCourseScreenHeader to display
    // levelA Subtheme name text

    // BUILD
    if (isNullOrUndefined(subtheme))
        return null
    return (
        <div>
            <span className={"font-medium text-[14px] text-greyLight7"}>
                {subtheme}
            </span>
        </div>
    );
}